import { clearCachedSession } from "./cachedSession";
import { clearDismissedCtas } from "./dismissedCtas";

/** Everything this app keeps on the device, cleared in one call.
    Both purge points — sign-out (App.tsx) and the API client's 401 choke
    point (main.tsx) — go through here so a new stored item can't be added
    to one and forgotten in the other. */
export function purgeClientState(): void {
  clearCachedSession();
  clearDismissedCtas();
}
